import React from 'react';
import cx from 'classnames';

import useStyles from '../styles';

interface IProps {
  icon: React.ReactNode;
  title: string | React.ReactNode;
  whiteColor?: boolean;
  onClick?: () => void;
  selected?: boolean;
}

const Chip: React.FC<IProps> = ({ icon, title, whiteColor, onClick, selected }) => {
  const classes = useStyles();

  return (
    <div
      className={cx(classes.chip, {
        [classes.activeChip]: onClick,
        [classes.selectedChip]: selected,
      })}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {icon}
      <div>{title}</div>
    </div>
  );
};

export default Chip;
